import { recordClick, recordCustomEvent } from './actions'
import { KalturaEvents } from './config'
import { getViewport } from './viewportListener'

export default (config, enableVTIMTracking) => {

  for (const [eventKey, event] of Object.entries(KalturaEvents)) {
    event.kalturaStateEvents.forEach((KMPEvent) => {
      if (enableVTIMTracking) {
        window.addEventListener(KMPEvent, eventListener)
      } else {
        window.addEventListener(KMPEvent, clickEventListener)
      }
    })
  }

  return () => {
    for (const [eventName, event] of Object.entries(KalturaEvents)) {
      event.kalturaStateEvents.forEach((KMPEvent) => {
        if (enableVTIMTracking) {
          window.removeEventListener(KMPEvent, eventListener)
        } else {
          window.removeEventListener(KMPEvent, clickEventListener)
        }
      })
    }
  }
}

const eventListener = (e) => {
  const elmId = e.target.id
  const elm = document.getElementById(elmId)
  const selectorName = elm.getAttribute('data-selector-name') || 'video_action'
  const customSelectorName = elm.getAttribute('data-custom-selector-name') || 'video_action_custom'
  const el = elm.getAttribute('data-ga-event-label') || elmId
  const eventType = e.type.slice(4)

  recordCustomEvent( (eventType === 'Play') ? selectorName : customSelectorName, {
    elementId: el,
    action: eventType
  })
}

const clickEventListener = (e) => {
  const elmId = e.target.id
  const elm = document.getElementById(elmId)
  const el = elm.getAttribute('data-ga-event-label') || elmId
  const eventType = e.type.slice(4)

  let trackingNameParts = [elm.getAttribute('data-tracking-name') || elmId]
  trackingNameParts.push(eventType)
  if(getViewport()) {
    trackingNameParts.push(getViewport())
  }
  const trackingName = trackingNameParts.join('_')

  recordClick(`#${el}`, trackingName)
}
